import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, requireModuleId, requireModuleUrl }) {
  const { user, loading, hasModule, modules } = useAuth();
  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireModuleId && !hasModule(requireModuleId)) return <div>No tienes acceso a este módulo.</div>;
  if (requireModuleUrl) {
    const found = modules.some(m => m.url === requireModuleUrl);
    if (!found) return <div>No tienes acceso a esta funcionalidad.</div>;
  }
  return children;
}